// @flow
import * as React from 'react';
import Iframe from 'react-iframe';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  updateCurrentCampaign,
  updateCampaign
} from '../actions/campaigns/campaignCreators';
import * as activeOrganisationCreators from '../actions/organisations/activeOrganisationCreators';
import { Alert } from 'react-bootstrap';
import { getSetting } from '../actions/settings/settingsCreators';
import CampaignHeader from '../components/CampaignHeader';
import LoadingSpinner from './LoadingSpinner';
import type { Dispatch } from 'redux';

type State = {
  isLoaded: boolean,
  currentCampaignId?: any,
  canExport: any,
  error?: any
};

type Params = {
  context: string,
  organisationId: number,
  campaignId: string | number
};

type Props = {
  params: Params,
  currentCampaign: Object,
  updateActiveOrganisation: Function,
  activeOrganisation: any,
  iFrameUrl: string,
  currentStep: number,
  settings: Object,
  updateCurrentCampaign: (cid: number, oid: number) => Promise<*>,
  getSetting: (s: string) => void
};

class Map extends React.Component<Props, State> {
  intervalId: IntervalID;

  constructor(props: Props) {
    super(props);

    this.state = {
      isLoaded: false,
      canExport: false
    };
  }

  componentDidMount() {
    const { organisationId } = this.props.params;
    const { getSetting } = this.props;
    this.updateCampaignId(this.props);
    this.props.updateActiveOrganisation(organisationId);
    getSetting('campaignHelpPdf');
    getSetting('campaignHelpVideo');
    this.pollLocalStorage();
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  componentWillReceiveProps(nextProps) {
    this.handleActiveOrganisationUpdate(nextProps);

    if (nextProps.params.campaignId !== this.props.params.campaignId) {
      const newCampaignId = parseInt(nextProps.params.campaignId, 10);

      this.setState({
        isLoaded: true,
        currentCampaignId: newCampaignId
      });

      this.updateCampaignId(nextProps);
    }
  }

  pollLocalStorage = () => {
    this.intervalId = setInterval(() => {
      const canExport = localStorage.getItem('canExport');
      if (this.state.canExport !== canExport) {
        this.setState({ canExport });

        // get currentCampaign again
        // (because the statusId will have changed)
        this.updateCampaignId(this.props);
      }
    }, 1000);
  };

  updateCampaignId = (props: Props) => {
    const currentOrgId = parseInt(props.params.organisationId, 10);
    if (currentOrgId) {
      const newCampaignId = parseInt(props.params.campaignId, 10);

      this.setState({ currentCampaignId: newCampaignId });

      this.props
        .updateCurrentCampaign(newCampaignId, currentOrgId)
        .then(
          success => this.setState({ isLoaded: true, error: null }),
          error => this.setState({ isLoaded: true, error: error.data.message })
        );
    }
  };

  handleActiveOrganisationUpdate = (nextProps: Props) => {
    const newOrganisationId = nextProps.activeOrganisation.id;
    if (newOrganisationId !== this.props.activeOrganisation.id) {
      this.props.updateActiveOrganisation(newOrganisationId);
    }
  };

  render() {
    const { settings } = this.props;
    const propsCampaignId = this.props.currentCampaign.id;
    const stateCampaignId = this.state.currentCampaignId;
    const iFrameUrl = this.props.iFrameUrl;

    if (this.state.isLoaded) {
      if (this.state.error) {
        return <Alert bsStyle="danger">{this.state.error}</Alert>;
      }
      if (propsCampaignId === stateCampaignId) {
        return (
          <div className="map-iframe-wrapper">
            <CampaignHeader
              campaignStatus={this.props.currentCampaign.statusTypeId}
              params={this.props.params}
              currentStep={this.props.currentStep}
              canExport={this.state.canExport}
              showSelect
              pdfUrl={
                settings && settings.campaignHelpPdf
                  ? settings.campaignHelpPdf.value
                  : ''
              }
              videoUrl={
                settings && settings.campaignHelpVideo
                  ? settings.campaignHelpVideo.value
                  : ''
              }
              campaignIsLocked={
                this.props.currentCampaign &&
                this.props.currentCampaign.isLocked
              }
            />
            {/* These values are the height of the navbar and campaign header bar. */}
            <Iframe
              url={iFrameUrl}
              width="100%"
              height="calc(100% - 73px - 47px)"
              title="Campaign Targeter - map and filters"
            />
          </div>
        );
      }
      return <LoadingSpinner />;
    }
    return <LoadingSpinner />;
  }
}

function mapStateToProps(state) {
  return {
    currentCampaign: state.currentCampaign,
    currentOrganisation: state.currentOrganisation,
    currentLocation: state.currentLocation,
    activeOrganisation: state.activeOrganisation,
    settings: state.settings
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  return bindActionCreators(
    {
      updateCurrentCampaign,
      updateCampaign,
      ...activeOrganisationCreators,
      getSetting
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Map);



// WEBPACK FOOTER //
// ./src/components/Map.js